import { allocateResourceError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getAllocateResourceError({ uuid }) {
      const req = getState().find(({ task }) => uuid === task.uuid);

      return req ? req.error : allocateResourceError;
    },
    isAllocateResourcesRequestFailure({ uuid }) {
      const state = getState().find(({ task }) => uuid === task.uuid);

      return state ? state.request.isFailure : false;
    },
    isAllocateResourcesRequestPending({ uuid }) {
      const state = getState().find(({ task }) => uuid === task.uuid);

      return state ? state.request.isPending : false;
    },
    isAllocateResourcesRequestSuccess({ uuid }) {
      const state = getState().find(({ task }) => uuid === task.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
